"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const core_1 = require("@material-ui/core");
const react_redux_1 = require("react-redux");
const style_1 = tslib_1.__importDefault(require("src/app/auto-ml/utils/style"));
function ModelTuningRCAStep1(props) {
    const { setModelSelection, errors, setErrorMessage } = props;
    const modelData = react_redux_1.useSelector((state) => state.model_selection);
    const [method, setMethod] = react_1.useState((modelData.model_selection && modelData.model_selection && modelData.model_selection.method) ? modelData.model_selection.method : "");
    const columns = react_redux_1.useSelector((state) => state.columnSelectionS22);
    const [eventColumns, setEvenColumns] = react_1.useState(columns && columns.finalUniqueColumns);
    console.log('model data', modelData);
    const styleLocal = style_1.default();
    react_1.useEffect(() => {
        const data = {
            method: method
        };
        setModelSelection(data);
    }, [method]);
    const handleMethod = (value) => {
        setMethod(value);
        setErrorMessage((prev) => (Object.assign({}, prev, { method: "" })));
    };
    return (react_1.default.createElement(core_1.Grid, { container: true },
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 3, lg: 3 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 6, lg: 6, style: { backgroundColor: "white", padding: "30px" } },
            react_1.default.createElement(core_1.Typography, { className: styleLocal.topicFont, component: "span", style: { padding: "0px 0px 20px", display: "flex" } }, "Choose the algorithm to be used for model training."),
            react_1.default.createElement(core_1.Typography, { variant: "h6" }, "Select Options"),
            react_1.default.createElement("br", null),
            react_1.default.createElement(core_1.Grid, { container: true, style: { marginBottom: "20px" } },
                react_1.default.createElement(core_1.Typography, { className: styleLocal.textFieldFont }, "Training Algorithm"),
                react_1.default.createElement(core_1.FormControl, { fullWidth: true },
                    react_1.default.createElement(core_1.Select, { labelId: "method-label", value: method, className: styleLocal.singleDropDown, onChange: (e) => handleMethod(e.target.value), variant: "outlined" },
                        react_1.default.createElement(core_1.MenuItem, { value: "bayesian" }, "Bayesian"))),
                errors && (react_1.default.createElement(core_1.Typography, { variant: "body2", color: "error", style: { fontSize: 11 } }, errors.method)))),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 3, lg: 3 })));
}
exports.ModelTuningRCAStep1 = ModelTuningRCAStep1;
//# sourceMappingURL=model-tuning-step-rcams-1.js.map